import React, { Component, createRef } from 'react';
import { withRouter } from 'react-router-dom';
import './home.css';
import { toastS } from 'react-toastify';
import Navbar from '../../componentes/navbar/navbar';
import SpinnerModal from '../../componentes/spiner/SpinnerModal';

class HomeScreen extends Component {
  state = {
    envivo: null,
    pendingEnvivo: null,
    boda: null,
    galeria: [],
    loading: false,

    showRefreshModal: false,
  };



  

  render() {
    const { history } = this.props;
    const { envivo, boda, galeria, loading, showRefreshModal } = this.state;

    if (loading) {
      return (
        <div className="page page-white">
          <SpinnerModal tipo="full" show={loading} />
        </div>
      );
    }

    return (
      <div className="page page-white">
        <Navbar />


        <div className="envivo-container">
          <h1 className="envivo-title">{boda?.titulo}</h1>
          <p className="envivo-date">{boda?.fechaboda}</p>

        </div>


      </div>
    );
  }
}

export default withRouter(HomeScreen);
